import { Dialog, Transition } from '@headlessui/react';
import { FC, HtmlHTMLAttributes, useEffect, useState } from 'react';
import tw from 'twin.macro';
import { XIcon } from '@heroicons/react/solid';
import { useForm } from 'react-hook-form';
import Email from '../../../layout-a/forms/common/Inputs//Email';
import SuccessPopup from '../../SuccessPopup';
import Image from 'next/image';
import { handleDataTracker } from '../../tracker';
import MasterClassContainer from '../../container';
import UgGradGQL from '../../../../lib/graphql/constants/upGrad/gql';
import { RESEND_OTP } from '../../../../lib/graphql/constants/upGrad/lead.gql';
import { VERIFY_OTP } from '../../../../lib/graphql/constants/upGrad/lead.gql';
import IMobileVerificationProps from '../MobileVerification/interface';
import PhoneNumber from '../../../layout-a/forms/common/Inputs/PhoneNumber';
import { EventData } from '../../../../lib/events/constants';
import UpGradSubmitHandler from '../submitHandler';
import { maskPhoneNumber } from '../../../../lib/common/common';

const CloseButton = tw.button`
  border-transparent
  outline-none
  z-50
`;

const DialogContainer = tw.div`
fixed
inset-0
bg-black
bg-opacity-25
transition-opacity
`;

const ButtonContainer = tw.div`
absolute
top-0
right-0
pt-4
pr-4
`;

const Title = tw.div`
text-center
text-xl
font-bold
leading-[26px]
mb-4
relative
`;

const ContentContainer = tw.div`
sm:flex 
sm:justify-center 
sm:items-center `;

const Content = tw.div`
  w-full sm:max-w-[447px] text-[#333333] font-regular text-sm leading-[21px]  mb-[55px] text-center
`;

const InfoContainer = tw.div`
w-full  flex 
pt-4
pb-6
md:p-0
`;

const Popup = tw.div`
relative
inline-block
bg-white
rounded-t-[3px] 
md:rounded-xl
text-left
overflow-hidden
shadow-xl
transform
transition-all
sm:my-1  
`;

const PopupContainer = tw.div`
flex
md:items-center
items-end
justify-center
min-h-screen
text-center
`;
const Overlay = tw.div`fixed inset-0 bg-black bg-opacity-50 transition-opacity`;

const OtpContainer = tw.div`w-12 h-12`;

const VerifyButtonContainer = tw.div`
flex 
justify-center 
items-center 

`;

const VerifyButton = tw.button`
w-full   
bg-[#db4144] 
text-white 
py-4
sm:w-[252px]
text-center 
font-semibold 
md:font-bold 
md:text-xl 
md:leading-6 
text-sm 
leading-[19px] 
rounded-[3px] 
md:rounded`;

const LeftContainer = tw.div`
  hidden md:flex md:w-[575px] bg-[#F8FAFE]  flex-col pl-[111px] pr-[83px] pt-10 pb-[23px]
`;
const RightContainer = tw.div`
  md:w-[625px] h-full p-4 md:px-8 md:py-6  
`;

const ContactUsContent = tw.p` 
font-regular 
text-sm 
leading-[19px] 
text-[#666666]
text-center`;

const FormContainer = tw.form`
    leading-[22px] text-[#444] text-sm
`;

const data = [
  { keyPoints: 'Complete Guidance to become a Full Stack Developer/ Data Scientist' },
  { keyPoints: 'Real-time understanding of industry relevant projects' },
  { keyPoints: 'Support and Guidance of industry experts' },
  { keyPoints: 'Hands-on live coding sessions and examples' },
  { keyPoints: 'Completion certificate with exciting offers' },
];

const MobileVerificationPopUpV2: FC<IMobileVerificationProps> = ({
  title,
  isOpen,
  setOpen,
  leadData,
  sectionName,
  setShowSuccessPopup,
  setShowBookYouSeatPopUp,
  webinarId,
  webinarDate,
  webinarEndDate,
  zoomLink,
  instructor,
  classType,
  setLeadData,
}) => {
  const [counter, setCounter] = useState(30);

  const [showResendOTPPopup, setShowResendOTPPopup] = useState(false);
  const [otp, setOtp] = useState([]);
  const [enableOtpButton, setEnableOtpButton] = useState(true);
  const [otpStatus, setOtpStatus] = useState(false);
  const [otpSendStatus, setOtpSendStatus] = useState(false);

  useEffect(() => {
    let timer = counter > 0 && isOpen && setTimeout(() => setCounter(counter - 1), 1000);
    return () => {
      clearInterval(timer);
    };
  }, [counter]);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitted },
    reset,
    setValue,
    getValues,
  } = useForm({
    mode: 'onTouched',
  });

  const [pageURL, setPageURL] = useState('');
  const inputProps = { register, errors, isSubmitted, setValue, getValues };

  const { leadIdentifier, phone, program, email } = leadData;
  let webinarStartTime = webinarDate;
  let webinarEndTime = webinarEndDate;

  // validateOtp
  const validateOtp = async () => {
    const userSubmittedOTP = otp.join('');

    const response = await UgGradGQL({
      query: VERIFY_OTP,
      variables: {
        input: {
          email,
          otp: userSubmittedOTP,
          phone,
          program,
          webinarId,
          zoomLink,
          webinarStartTime,
          webinarEndTime,
          instructor,
          classType,
        },
      },
      queryName: 'verifyOTP',
      queryType: 'mutation',
      context: 'verifyOTP',
    });

    if (response.data) {
      setOtpStatus(false);
      close();
      setShowSuccessPopup(true);
      setOpen(false);
      handleDataTracker(`${sectionName}-otp`, '', program, leadData);
    } else {
      setOtpStatus(true);
      setOtpSendStatus(false);
    }
  };

  // close
  const close = () => {
    setOtpStatus(false);
    setOpen(false);
    document.body.style.overflow = 'auto';
  };
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }
  }, [isOpen]);

  useEffect(() => {
    setPageURL(window.location.href);
  }, []);

  // inputOnChange
  const inputOnChange = (e, i) => {
    const value = e.target.value;

    if (!new RegExp(/^\d+$/).test(value)) {
      otp[i] = '';
    } else {
      otp[i] = value;
    }

    if (e.nativeEvent.inputType === 'deleteContentBackward') {
      const nextSibling: HTMLElement = document.querySelector(`input[name=otp-${parseInt(i) - 1}]`);

      if (nextSibling !== null) {
        if (i != 0) {
          nextSibling.focus();
        }
      }
    } else {
      const nextSibling: HTMLElement = document.querySelector(`input[name=otp-${parseInt(i) + 1}]`);

      if (nextSibling !== null) {
        if (i != 3) {
          nextSibling.focus();
        }
      }
    }

    setOtp(otp);

    let otpFilter = otp.filter(function (el) {
      return el;
    });
    if (otpFilter.length == 4) {
      setEnableOtpButton(false);
    } else {
      setEnableOtpButton(true);
    }
  };

  // sendOtpMail
  const sendOtpMail = async () => {
    setCounter(30);

    const response = await UgGradGQL({
      query: RESEND_OTP,
      variables: { input: { email, phone } },
      queryName: 'resendOTP',
      queryType: 'mutation',
      context: 'resendOTP',
    });

    if (response.data) {
      setOtpSendStatus(true);
      setOtpStatus(false);
    }
  };

  const onChangePhoneNumber = async (data: any) => {
    const storedFormValues: any = JSON.parse(localStorage.getItem('formData'));
    storedFormValues['phone'] = data.phone;
    storedFormValues['isd'] = data.isd;
    const eName = EventData[sectionName.replace('click-register', 'submit')]?.name;
    const eLabel = EventData[sectionName.replace('click-register', 'submit')]?.label;
    const extraData = {
      leadType: storedFormValues['static_lead_type'],
      static_lead_type: storedFormValues['static_lead_type'],
      page: `${pageURL}`,
      action: 'Submit',
      name: eName,
      label: eLabel,
      program: storedFormValues['program'],
    };

    const response = await UpGradSubmitHandler(storedFormValues, extraData, reset);

    if (response) {
      setCounter(30);
      setLeadData(response.response);
      setShowResendOTPPopup(false);
      setOtpSendStatus(true);
      setOtpStatus(false);
    }
  };

  return (
    <>
      <div className="absolute">
        <Transition.Root show={isOpen}>
          <div className="fixed z-[250] inset-0 overflow-y-auto">
            <MasterClassContainer>
              <PopupContainer className="flex md:items-center items-end justify-center text-center sm:block sm:p-0">
                <Transition.Child
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Overlay />
                </Transition.Child>

                <Transition.Child
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Popup className="sm:w-[1200px] w-full -mb-[6px] md:mb-0">
                    <ButtonContainer className="z-[250]">
                      <CloseButton type="button" onClick={close}>
                        <XIcon className="w-5 hover:text-[#585858]" />
                      </CloseButton>
                    </ButtonContainer>
                    <InfoContainer>
                      <LeftContainer>
                        <div className="relative text-center mb-10">
                          <img
                            src={'https://d2o2utebsixu4k.cloudfront.net/master-class/bookseatv2.png'}
                            width="381"
                            height="320"
                          />
                        </div>
                        <div className="text-black text-2xl font-bold leading-[31px] mb-4">Book Your Seat To Get</div>
                        <div className=" text-[14px] text-[#333333] leading-[21px]">
                          {data.map((ele, index) => {
                            return (
                              <div className="flex gap-x-1 mb-2 items-center" key={index}>
                                <div className="w-[10px] h-[10px]">
                                  <img
                                    src="https://d2o2utebsixu4k.cloudfront.net/master-class/arrow-right.png"
                                    width="10"
                                    height="10"
                                    className="align-middle"
                                  />
                                </div>
                                <div className="flex-1 h-[21px]  w-full overflow-hidden">{ele.keyPoints}</div>
                              </div>
                            );
                          })}
                        </div>
                      </LeftContainer>
                      <RightContainer>
                        {showResendOTPPopup ? (
                          <>
                            <div className="hidden md:block">
                              <div className="flex justify-center items-center">
                                <div className="w-8 h-8">
                                  <img
                                    src="https://d2o2utebsixu4k.cloudfront.net/master-class/tick.png"
                                    height="32"
                                    width="32"
                                  />
                                </div>
                                <div className=" w-[120px] h-[2px] bg-[#20C377]"></div>
                                <div className="w-8 h-8 border-[2px] rounded-full inline-flex justify-center items-center font-bold text-sm leading-[19px] border-[#20C377] text-[#20C377]">
                                  2
                                </div>
                              </div>
                              <div className="mt-2 flex justify-center gap-x-[71px] items-center">
                                <div className="font-bold text-sm leading-[19px] ">Basic Details</div>
                                <div className="text-sm leading-[19px] text-[#999999]">Verify OTP</div>
                              </div>
                            </div>
                            <div className="block ml-2 md:hidden">
                              <div className="flex  items-center">
                                <div className="w-8 h-8">
                                  <img
                                    src="https://d2o2utebsixu4k.cloudfront.net/master-class/tick.png"
                                    height="32"
                                    width="32"
                                  />
                                </div>
                                <div className=" w-[73px] rounded-[7px] h-[4px] mx-3 bg-[#20C377]"></div>
                                <div className="w-8 h-8">
                                  <img
                                    src="https://d2o2utebsixu4k.cloudfront.net/master-class/progress.png"
                                    height="32"
                                    width="32"
                                  />
                                </div>
                              </div>
                              <div className="flex gap-x-10">
                                <div>
                                  <div className="font-semibold uppercase mt-4 mb-1 text-[10px] leading-[13px] text-[#666666] ">
                                    Step 1
                                  </div>
                                  <div className="font-bold text-sm leading-[19px] ">Basic Details</div>
                                  <div className=" mt-3  py-1 px-3 rounded-[23px]  bg-[#20C377]/10 font-semibold text-[10px] leading-[13px] text-[#20C377] ">
                                    Completed
                                  </div>
                                </div>
                                <div>
                                  <div className="font-semibold uppercase mt-4 mb-1 text-[10px] leading-[13px] text-[#999999]">
                                    Step 2
                                  </div>
                                  <div className="text-sm font-bold leading-[19px] text-[#999999]">Verify OTP</div>
                                  <div className=" mt-3  py-1 px-3 rounded-[23px]  border border-[#999999] font-semibold text-[10px] leading-[13px]text-[#999999]">
                                    Pending
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="border-t border-black/10 mt-5 mb-[22px]"></div>
                            <Title className=" mb-4 text-left md:text-center">{title}</Title>
                            <ContentContainer>
                              <div className="text-[#333333] font-regular text-sm leading-[21px] text-center   mb-10 sm:mb-[67px]">
                                Please enter the phone number you wish to receive the OTP in
                              </div>
                            </ContentContainer>
                            <ContentContainer>
                              <FormContainer onSubmit={handleSubmit(onChangePhoneNumber)}>
                                <div className="w-full sm:w-[286px]">
                                  <PhoneNumber {...inputProps} asterisk={true} fullWidth={true} />
                                </div>
                                <VerifyButtonContainer className="mb-6 md:mb-0">
                                  <button
                                    type="submit"
                                    className=" w-full sm:w-[129px] font-semibold sm:font-bold text-sm leading-[19px] md:text-base md:leading-[19px] bg-[#db4144] text-white py-4 rounded-[3px] md:rounded"
                                  >
                                    Get OTP
                                  </button>
                                </VerifyButtonContainer>
                              </FormContainer>
                            </ContentContainer>
                          </>
                        ) : (
                          <>
                            <div className="hidden md:block">
                              <div className="flex justify-center items-center">
                                <div className="w-8 h-8">
                                  <img
                                    src="https://d2o2utebsixu4k.cloudfront.net/master-class/tick.png"
                                    height="32"
                                    width="32"
                                  />
                                </div>
                                <div className=" w-[120px] h-[2px] bg-[#20C377]"></div>
                                <div className="w-8 h-8 border-[2px] rounded-full inline-flex justify-center items-center font-bold text-sm leading-[19px] border-[#20C377] text-[#20C377]">
                                  2
                                </div>
                              </div>
                              <div className="mt-2 flex justify-center gap-x-[71px] items-center">
                                <div className="font-bold text-sm leading-[19px] ">Basic Details</div>
                                <div className="text-sm leading-[19px] text-[#999999]">Verify OTP</div>
                              </div>
                            </div>
                            <div className="block ml-2 md:hidden">
                              <div className="flex  items-center">
                                <div className="w-8 h-8">
                                  <img
                                    src="https://d2o2utebsixu4k.cloudfront.net/master-class/tick.png"
                                    height="32"
                                    width="32"
                                  />
                                </div>
                                <div className=" w-[73px] rounded-[7px] h-[4px] mx-3 bg-[#20C377]"></div>
                                <div className="w-8 h-8">
                                  <img
                                    src="https://d2o2utebsixu4k.cloudfront.net/master-class/progress.png"
                                    height="32"
                                    width="32"
                                  />
                                </div>
                              </div>
                              <div className="flex gap-x-10">
                                <div>
                                  <div className="font-semibold uppercase mt-4 mb-1 text-[10px] leading-[13px] text-[#666666] ">
                                    Step 1
                                  </div>
                                  <div className="font-bold text-sm leading-[19px] ">Basic Details</div>
                                  <div className=" mt-3  py-1 px-3 rounded-[23px]  bg-[#20C377]/10 font-semibold text-[10px] leading-[13px] text-[#20C377] ">
                                    Completed
                                  </div>
                                </div>
                                <div>
                                  <div className="font-semibold uppercase mt-4 mb-1 text-[10px] leading-[13px] text-[#999999]">
                                    Step 2
                                  </div>
                                  <div className="text-sm font-bold leading-[19px] text-[#999999]">Verify OTP</div>
                                  <div className=" mt-3  py-1 px-3 rounded-[23px]  border border-[#999999] font-semibold text-[10px] leading-[13px]text-[#999999]">
                                    Pending
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="border-t border-black/10 mt-5 mb-[22px] "></div>
                            <Title>{title}</Title>
                            <ContentContainer>
                              <Content>
                                {`Please verify your Mobile number to receive your Webinar Joining link from upGrad. By the way, we have sent a code to your Mobile number ${maskPhoneNumber(
                                  leadData.phone
                                )} `}
                                {`(Want to change mobile number ? `}
                                <span
                                  onClick={() => {
                                    setShowResendOTPPopup(true);
                                  }}
                                  className="text-[#107BD4] font-medium underline cursor-pointer"
                                >
                                  Click here
                                </span>
                                {')'}
                              </Content>
                            </ContentContainer>

                            <div className="flex flex-row items-center justify-between mx-auto w-full max-w-xs">
                              <OtpContainer>
                                <input
                                  className="w-full h-full flex flex-col items-center justify-center text-center px-2 outline-none rounded border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                                  type="number"
                                  name="otp-0"
                                  onChange={(e) => inputOnChange(e, 0)}
                                  maxLength={1}
                                />
                              </OtpContainer>
                              <OtpContainer>
                                <input
                                  className="w-full h-full flex flex-col items-center justify-center text-center px-2 outline-none rounded border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                                  type="number"
                                  name="otp-1"
                                  onChange={(e) => inputOnChange(e, 1)}
                                  maxLength={1}
                                />
                              </OtpContainer>
                              <OtpContainer>
                                <input
                                  className="w-full h-full flex flex-col items-center justify-center text-center px-2 outline-none rounded border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                                  type="number"
                                  name="otp-2"
                                  onChange={(e) => inputOnChange(e, 2)}
                                  maxLength={1}
                                />
                              </OtpContainer>
                              <OtpContainer>
                                <input
                                  className="w-full h-full flex flex-col items-center justify-center text-center px-2 outline-none rounded border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
                                  type="number"
                                  name="otp-3"
                                  onChange={(e) => inputOnChange(e, 3)}
                                  maxLength={1}
                                />
                              </OtpContainer>
                            </div>
                            {otpStatus && (
                              <div className="mx-auto w-full max-w-xs flex justify-center items-center mt-[6px]">
                                <span className="text-red-500 md:text-sm text-xs leading-4">
                                  OTP Verification Failed
                                </span>
                              </div>
                            )}

                            {otpSendStatus && (
                              <div className="mx-auto w-full max-w-xs flex justify-center items-center mt-[6px]">
                                <span className="text-red-500 md:text-sm text-xs leading-4">
                                  OTP sent successfully.
                                </span>
                              </div>
                            )}

                            <div className=" md:mt-[55px] mt-10  text-center mb-10 md:mb-8 font-semibold text-sm leading-[19px]  ">
                              {counter == 0 ? (
                                <span onClick={sendOtpMail}>
                                  <label className="text-blue-500 cursor-pointer">Resend OTP</label>
                                </span>
                              ) : (
                                <>
                                  Didn’t recieve OTP? Resend in <span className="text-[#D85E59]">{counter}</span> sec
                                </>
                              )}
                            </div>
                            <VerifyButtonContainer className="md:mb-8 mb-6">
                              <VerifyButton
                                className={`${enableOtpButton ? 'bg-[#db4144]/70 cursor-not-allowed' : 'bg-[#db4144]'}`}
                                onClick={() => {
                                  validateOtp();
                                }}
                                disabled={enableOtpButton}
                                name="verifyOTP"
                              >
                                Verify and get link
                              </VerifyButton>
                            </VerifyButtonContainer>
                          </>
                        )}
                        <ContactUsContent className="mt-8">
                          Have any further questions &nbsp;
                          <a
                            className="font-semibold text-black underline"
                            target={'_blank'}
                            href="mailto:bootcampsupport@upgrad.com"
                            rel="noreferrer noopener"
                          >
                            Contact Us
                          </a>
                        </ContactUsContent>
                      </RightContainer>
                    </InfoContainer>
                  </Popup>
                </Transition.Child>
              </PopupContainer>
            </MasterClassContainer>
          </div>
        </Transition.Root>
      </div>
    </>
  );
};

export default MobileVerificationPopUpV2;
